var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-logout-541763_1_",
    "data-name": "noun-logout-541763 (1)",
    transform: "translate(-0.006 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_260863",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 260863",
    d: "M14.481,24H1.88A1.882,1.882,0,0,1,.006,22.117V1.891A1.882,1.882,0,0,1,1.88,0h12.6a1.882,1.882,0,0,1,1.874,1.887V5.524a.477.477,0,1,1-.953,0V1.891a.925.925,0,0,0-.92-.927H1.88a.925.925,0,0,0-.92.927V22.117a.925.925,0,0,0,.92.927h12.6a.925.925,0,0,0,.92-.927V18.2a.477.477,0,1,1,.953,0v3.921A1.883,1.883,0,0,1,14.481,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_260864",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 260864",
    d: "M338.4,576.487a.487.487,0,0,1,.487-.487h15.6a.487.487,0,0,1,0,.975h-15.6A.487.487,0,0,1,338.4,576.487Z",
    transform: "translate(-331.89 -564.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_260865",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 260865",
    d: "M954.265,377.962l-4.1-4.1a.487.487,0,0,1,.689-.689l4.1,4.1a.487.487,0,1,1-.689.689Z",
    transform: "translate(-931.092 -365.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_260866",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 260866",
    d: "M950.194,581.95a.488.488,0,0,1,0-.689l4.1-4.1a.487.487,0,0,1,.689.689l-4.1,4.1a.487.487,0,0,1-.689,0Z",
    transform: "translate(-931.121 -565.519)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.64a3785159809fe01d28412936136203.svg";
export { ForwardRef as ReactComponent };